import { Link } from "react-router-dom";
import { FlaskConical } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center px-6 text-center" data-testid="not-found-page">
      <FlaskConical className="h-10 w-10 text-brandblue-600 mb-5" strokeWidth={1.5} />
      <h1 className="text-5xl font-display font-bold text-slate-900">404</h1>
      <p className="mt-3 text-slate-600">This research page could not be located.</p>
      <Link to="/"><Button className="mt-8 rounded-full btn-lift" data-testid="not-found-home-btn">Return Home</Button></Link>
    </div>
  );
}
